import React, { useEffect, useState } from 'react'
import { Geolocation } from '@capacitor/geolocation'
import { isPlatformWeb } from '../../utilities/platform.util'
import './GoogleMap.component.css'

interface GoogleMapsProps {
  address: string
  city?: string
  state?: string
  zip?: string
  country?: string
}

const GoogleMap: React.FC<GoogleMapsProps> = ({ address, city, state, zip, country }: GoogleMapsProps) => {
  const mapAddress = `${address}${city ? ',' + city : ''}${state ? ',' + state : ''}${zip ? ' ' + zip : ''}${
    country ? ',' + country : ''
  }`
  const destination = encodeURI(mapAddress)

  const [startingPoint, setStartingPoint] = useState(String)

  useEffect(() => {
    if (isPlatformWeb()) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(success, fail)
      }
    } else {
      setCurrentPosition()
    }
  }, [])

  function success(position: any) {
    const point = encodeURI(`${position.coords.latitude},${position.coords.longitude}`)
    setStartingPoint(point)
  }

  function fail() {
    setStartingPoint('')
  }

  async function setCurrentPosition() {
    const coordinates = await Geolocation.getCurrentPosition()
    const point = encodeURI(`${coordinates.coords.latitude},${coordinates.coords.longitude}`)
    setStartingPoint(point)
  }

  return (
    <a
      href={`https://www.google.com/maps/dir/?api=1&origin=${startingPoint}&destination=${destination}`}
      target='_blank'
      rel='noopener noreferrer'
      aria-label='Google Map'
      data-testid='GoogleMap'>
      <img src='/assets/images/google-maps-icon.svg' className='google-maps-icon-svg' alt='location' />
    </a>
  )
}

export default GoogleMap
